import { ModalMenu } from "./AddMedicalCardModal";

import { isFemale } from "src/utils/gender";

export const getMedcardMenus = (t: any, rowID?: string, age?: number, gender?: string): ModalMenu[] => {

  const menuMC: ModalMenu[] = [
    {
      id: "0",
      name: "Hasta Tabelası",
      image: "/assets/icons/nurse/patient-table.svg",
      url: `/nurse/patient-table/${rowID}`,
    },
    {
      id: "1",
      or_id: "2586",
      name: "Pediatrik Travma Skoru",
      icon: "mdi-light:star",
      url: `/medcard/pediatric-trauma-score/${rowID}?orId=2586&cardName=PEDIATRIC_TRAUMA_SCORE`,
    },
    {
      id: "2",
      or_id: "2574",
      name: "Snap-II Skor Formu",
      icon: "mdi-light:star",
      url: `/medcard/snap2-score/${rowID}}?orId=2574&cardName=SNAP_II_SCORE`,
    },
    {
      id: "3",
      or_id: "2613",
      name: t("improve-bleeding-risk.title"),
      icon: "mdi-light:star",
      url: `/medcard/improve-blood-risk/${rowID}?orId=2613&cardName=IMPROVE_BLEEDING_RISK`,
    },
    {
      id: "4",
      or_id: "2571",
      name: " Glasgow Skoru",
      icon: "mdi-light:star",
      url: `/medcard/glasgow-score/${rowID}?orId=2571&cardName=GLASGOW_SCORE`,
    },

    {
      id: "6",
      or_id: "2614",
      name: t("improve-vte-risk-assessment.title"),
      icon: "mdi-light:star",
      url: `/medcard/improve-vte-risk-assessment/${rowID}?orId=2614&cardName=IMPROVE_VTE_RISK_ASSESSMENT`,
    },
    {
      id: "7",
      or_id: "2569",
      name: " Gebelikte Venöz Risk (VTE) Değerlendirme Formu",
      icon: "mdi-light:star",
      url: `/medcard/pregnancy-venous/${rowID}?orId=2569`,
    },
    {
      id: "8",
      or_id: "2618",
      name: " Nih İnme Skalası",
      icon: "mdi-light:star",
      url: `/medcard/nihss-score/${rowID}?orId=2618`,
    },
    {
      id: "9",
      or_id: "2562",
      name: "Sofa Skoru Formu",
      icon: "mdi-light:star",
      url: `/medcard/sofa-score/${rowID}?orId=2562&cardName=SOFA_SCORE`,
    },
    {
      id: "10",
      or_id: "2608",
      name: " Crib Skor Formu",
      icon: "mdi-light:star",
      url: `/medcard/crib-score/${rowID}?orId=2608`,
    },
    {
      id: "11",
      or_id: "2557",
      name: t("fall-risk-itaki-harizmi.title"),
      icon: "mdi-light:star",
      url:
        (age !== undefined && age < 18)
          ? `/medcard/fall-risk-harizmi/${rowID}?orId=2557&cardName=FALL_RISK_HARIZMI`
          : `/medcard/fall-risk-itaki/${rowID}?orId=2557&cardName=FALL_RISK_ITAKI`,
    },
    {
      id: "12",
      or_id: "2581",
      name: t("strong-kids.strong-kids.title2"),
      icon: "mdi-light:star",
      url: `/medcard/strong-kids/${rowID}?orId=2581`,
    },
    {
      id: "13",
      or_id: "2585",
      name: " Ema Sepsis Skor Formu",
      icon: "mdi-light:star",
      url: `/medcard/ema-sepsis-score/${rowID}?orId=2585`,
    },

    {
      id: "16",
      or_id: "2605",
      name: " Can Skoru",
      icon: "mdi-light:star",
      url: `/medcard/can-scale/${rowID}?orId=2605&cardName=CAN_SCALE`,
    },
    {
      id: "17",
      or_id: "2607",
      name: " Neomod Skoru",
      icon: "mdi-light:star",
      url: `/medcard/neomod-score/${rowID}?orId=2607`,
    },
    {
      id: "18",
      or_id: "2578",
      name: "Pelod Skor Formu",
      icon: "mdi-light:star",
      url: `/medcard/pelod-score/${rowID}?orId=2578`,
    },
    {
      id: "19",
      or_id: "9996",
      name: t("northomton-score.title"),
      icon: "mdi-light:star",
      url: `/medcard/northomton-score/${rowID}?orId=9996`,
    },
    {
      id: "20",
      or_id: "9995",
      name: t("newborn-nutrition.newborn-nutrition-form"),
      icon: "mdi-light:star",
      url: `/medcard/newborn-nutrition/${rowID}?orId=9995`,
    },
    {
      id: "21",
      or_id: "2576",
      name: "Töllner Sepsis Formu",
      icon: "mdi-light:star",
      url: `/medcard/tollner-sepsis/${rowID}?orId=2576`,
    },
    {
      id: "22",
      or_id: "2621",
      name: "Anne Düşme Risk Ölçeği",
      icon: "mdi-light:star",
      url: `/medcard/mother-fall-risk-assessment/${rowID}?orId=2621`,
    },
    {
      id: "23",
      or_id: "2550",
      name: "Bası Yarası Riski Braden",
      icon: "mdi-light:star",
      url: `/medcard/basi-braden/${rowID}?orId=2550`,
    },
    {
      id: "24",
      or_id: "2587",
      name: "Waterlow Skalası",
      icon: "mdi-light:star",
      url: `/medcard/waterlow-score/${rowID}?orId=2587`,
    },
    {
      id: "25",
      or_id: "2573",
      name: "ApacheII Skoru",
      icon: "mdi-light:star",
      url: `/medcard/apacheii-score/${rowID}?orId=2573`,
    },
    {
      id: "26",
      or_id: "2575",
      name: "Partograf Formu",
      icon: "mdi-light:star",
      url: `/medcard/partograf/${rowID}?orId=2575`,
      disabled: gender !== undefined && !isFemale(gender),
      disabledMessage: "Bu form sadece kadın hastalar içindir.",
    },
    {
      id: "28",
      or_id: "2572",
      name: t("prism-score.title"),
      icon: "mdi-light:star",
      url: `/medcard/prism-score/${rowID}?orId=2572&cardName=PRISM_SCORE`,
    },
    {
      id: "29",
      or_id: "9993",
      name: t("revised-trauma-score.title"),
      icon: "mdi-light:star",
      url: `/medcard/revised-trauma-score/${rowID}?orId=9993`
    },
    {
      id: "30",
      or_id: "2558",
      name: t("catheter-material-tracking.catheter-material-tracking-title"),
      icon: "mdi-light:star",
      url: `/medcard/catheter-material-tracking/${rowID}?orId=2558`,
    },
    {
      id: "31",
      or_id: "2554",
      name: t("newborn-skin-risk-assessment.title"),
      icon: "mdi-light:star",
      url: `/medcard/newborn-skin-risk-assessment/${rowID}?orId=2554&cardName=NEWBORN_SKIN_RISK_ASSESSMENT`,
      ageWarning: (age !== undefined && age >= 1) ? t("newborn-skin-risk-assessment.age-warning") : undefined,
    },
    {
      id: "32",
      or_id: "2564",
      name: t("adverse-effect-form.title"),
      icon: "mdi-light:star",
      url: `/medcard/adverse-effect-form/${rowID}?orId=2564`,
    },
    {
      id: "33",
      or_id: "2606",
      name: t("blood-sugar-trace.title"),
      icon: "mdi-light:star",
      url: `/medcard/blood-sugar-trace/${rowID}?orId=2606`,
    },
    {
      id: "34",
      or_id: "9993",
      name: t("wound-assess.title"),
      icon: "mdi-light:star",
      url: `/medcard/wound-assess/${rowID}?orId=9993`,
    },
    {
      id: "35",
      or_id: "2577",
      name: t("safe-birth-control-form.title"),
      icon: "mdi-light:star",
      url: `/medcard/safe-birth-control/${rowID}?orId=2577`,
    },
    {
      id: "36",
      or_id: "2579",
      name: t("vte-risk-factor-evaluation.vte-risk-factor-evaluation"),
      icon: "mdi-light:star",
      url: `/medcard/vte-risk-faktor-evaluation/${rowID}?orId=2579&cardName=VTE_RISK_FACTOR_EVALUATION`,
    },
    {
      id: "37",
      or_id: "2559",
      name: t("adult-patient-assessment.title"),
      icon: "mdi-light:star",
      url:
        (age !== undefined && age < 18)
          ? `/medcard/child-patient-assessment/${rowID}?orId=2560&cardName=CHILD_PATIENT_ASSESSMENT`
          : `/medcard/adult-patient-assessment/${rowID}?orId=2559&cardName=ADULT_PATIENT_ASSESSMENT`,
    },
    {
      id: "38",
      or_id: "9989",
      name: t("blood-transfusion.title"),
      icon: "mdi-light:star",
      url: `/medcard/blood-transfusion/${rowID}?orId=9989`,
    },
    {
      id: "39",
      or_id: "2584",
      name: t("saps2-score.title"),
      icon: "mdi-light:star",
      url: `/medcard/saps2/${rowID}?orId=2584&cardName=SAPS2_SCORE`,
    },
    {
      id: "40",
      or_id: "2561",
      name: t("nutritional-risk-score.title"),
      icon: "mdi-light:star",
      url: `/medcard/nutrition-risk-score/${rowID}?orId=2561&cardName=MCNutritionalRiskScore`,
    },
    {
      id: "41",
      or_id: "9990",
      name: "Şiroz Şiddet Tayini",
      icon: "mdi-light:star",
      url: `/medcard/cirrhosis-violence/${rowID}?orId=9990`,
    },
    {
      id: "42",
      or_id: "2565",
      name: t("newborn-patient-assessment.title"),
      icon: "mdi-light:star",
      url: `/medcard/newborn-patient-assessment/${rowID}?orId=2565`,
    }, {
      id: "43",
      or_id: "2582",
      name: t("surgery-pre-post-preparation.title"),
      icon: "mdi-light:star",
      url: `/medcard/surgery-pre-post-preparation/${rowID}?orId=2582`,
    },
    {
      id: "44",
      or_id: "3503",
      name: t("tab-names.casus-score"),
      icon: "mdi-light:star",
      url: `/medcard/casus-score/${rowID}?orId=3503&cardName=CASUS_SCORE`,
    },
    {
      id: "45",
      or_id: "2625",
      name: t("tab-names.modify.aldetre.score"),
      icon: "mdi-light:star",
      url: `/medcard/modify-aldetre-score/${rowID}?orId=2625&cardName=ALDETRE_SCORE`,
    },
    {
      id: "46",
      or_id: "2622",
      name: t("tab-names.acute-ghvd-clinical-scoring"),
      icon: "mdi-light:star",
      url: `/medcard/acute-ghvd-clinical-scoring/${rowID}?orId=2622&cardName=ACUTE_GHVD_CLINICAL_SCORING`,
    },
    {
      id: "48",
      or_id: "2615",
      name: t("tab-names.caprini-risk-assessment"),
      icon: "mdi-light:star",
      url: `/medcard/caprini-risk-assessment/${rowID}?orId=2615&cardName=CAPRINI_RISK_ASSESSMENT`,
    },
    {
      id: "49",
      or_id: "2555",
      name: t("tab-names.pain-assessment-scale"),
      icon: "mdi-light:star",
      url: `/medcard/pain-assessment-scale/${rowID}?orId=2555&cardName=PAIN_ASSESSMENT_SCALE`,
    },
    {
      id: "49",
      or_id: "2563",
      name: " Euro Skoru",
      icon: "mdi-light:star",
      url: `/medcard/euro-score/${rowID}?orId=2563&cardName=EURO_SCORE`,
    },
    {
      id: '51',
      or_id: '2553',
      name: 'Sıvı Dengesi Takibi',
      icon: 'mdi-light:star',
      url: `/medcard/fluid-balance/${rowID}?orId=2553&cardName=FLUID_BALANCE`,
    },
    {
      id: "47",
      or_id: "2604",
      name: t("tab-names.edineburgh-dept-scale"),
      icon: "mdi-light:star",
      url: `/medcard/edineburgh-dept-scale/${rowID}?orId=2604&cardName=EDINEBURGH_DEPT_SCALE`,
      disabled: gender !== undefined && !isFemale(gender),
      disabledMessage: "Bu form sadece kadın hastalar içindir.",
    },
  ];

  return menuMC.sort((a, b) => a.name.localeCompare(b.name));
};
